module.exports = __webpack_public_path__ + "static/type-hierarchy-light-b525f8950d7eb15d9b29515b65294460.svg";